import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
// import mergePDFs from "@/utils/createPdfBlob.js";

async function createPdf(data) {
  try {
    // Create a new PDFDocument
    const pdfDoc = await PDFDocument.create();

    // Embed the Times Roman font
    const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

    // Add a blank page to the document
    const page = pdfDoc.addPage();

    // Get the width and height of the page
    const { height } = page.getSize();

    // Draw a string of text toward the top of the page
    const fontSize = 30;
    page.drawText(data, {
      x: 50,
      y: height - 4 * fontSize,
      size: fontSize,
      font: timesRomanFont,
      color: rgb(0, 0.53, 0.71),
    });

    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save();
    // let url = await mergePDFs(pdfBytes);
    console.log(pdfBytes);
    return pdfBytes;
  } catch (error) {
    console.error("Error creating PDF: ", error);
    throw error; // Rethrow the error to handle it at a higher level if needed
  }
}

export default createPdf;
